import { TJobItem } from "../../../../features/organization/job/job.type";
import { formatDate } from "../../../../lib/time";
import { underscoreToCapitalizeString } from "../../../../utils/utils";
import { jobStatusList } from "../../job/_data/data";

type Props = {
  data: TJobItem;
};

export default function ProposalLevel({ data }: Props) {
  return (
    <div className="max-w-[80%] ">
      <h3 className="text-lg font-medium text-header  !inline-block break-all whitespace-normal mb-1">
        {data?.job_title}
      </h3>

      <div className="flex items-center gap-4">
        <ul className="flex items-center gap-6">
          <li>{underscoreToCapitalizeString(data?.job_category)}</li>
          {!!data?.contract_type && (
            <li>{underscoreToCapitalizeString(data?.contract_type)}</li>
          )}
          <li>
            Job Posted: {data?.created_at ? formatDate(data?.created_at) : "-"}
          </li>
        </ul>

        <div className="flex items-center gap-1.5">
          {/* {
            <StatusItem
              value={data?.status}
              label={data?.status === "posted" ? "Published" : undefined}
              list={jobStatusList}
              className="!px-3"
            />
          } */}
          {data?.status === "posted" && (
            <span className={`!px-3 status ${jobStatusList[0].className}`}>
              Published
            </span>
          )}
          {data?.number_of_people_hired > 0 ? (
            <span className="!px-3 status-success">
              Hired ({data?.number_of_people_hired || 0})
            </span>
          ) : null}
          <span className="!px-3 status-warning">
            Proposals ({data?.number_of_people_applied || 0})
          </span>
        </div>
      </div>
    </div>
  );
}
